
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/thermostat",
      function () {
        return require("private-next-pages/services/thermostat/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/thermostat"])
      });
    }
  